/**
 * Cognito Hosted UI doesn't honor `signoutRedirect` from oidc-client-ts the
 * way standard OIDC providers do — you need to hit the Hosted UI's `/logout`
 * endpoint with `client_id` and `logout_uri` to actually clear the session
 * cookie. We then handle the local-state cleanup ourselves.
 */
export function buildCognitoLogoutUrl(): string {
  const hostedUi = import.meta.env.VITE_COGNITO_HOSTED_UI;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  const logoutUri = import.meta.env.VITE_LOGOUT_URI;
  return `${hostedUi}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}
